module.exports = __webpack_public_path__ + "static/media/capa-emissor.cbd43fc0.png";